import { FiltersResponse } from '@interfaces/searchFilters'
import { api } from '@utils/api/api'

export const getSearchFilters = (): Promise<FiltersResponse> => {
  return api.get(`/api/v2/mobile/assets/filters`)
}
